import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as groupsActionTypes } from '../../actions/groups';

export default makeCrudMetaReducer(groupsActionTypes);
